import React from "react";
import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  Toolbar,
  ListButton,
  SaveButton,
  DateInput,
} from "react-admin";

import { RichTextInput } from 'ra-input-rich-text';

import { onMarketResearchCustomizationEdit } from "../../Service/Validation/MarketResearchCustomizationValidation";
import Grid from "@material-ui/core/Grid";

const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const PageTitle = ({ record }) => {
  return <span>Basic Plan: {record ? record.name : ""}</span>;
};
const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="list" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);

const MarketResearchCustomizationEdit = (props) => {
  return (
    <Edit title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm warnWhenUnsavedChanges toolbar={<FormToolbar />} defaultValues={{ action: "full" }} validate={onMarketResearchCustomizationEdit} redirect="list">
        <SanitizedGrid container spacing={3} fullWidth>

          <Grid item sm={12} md={12} lg={6}>
            <TextInput label="Title" source="title" fullWidth />
          </Grid>
          <Grid item sm={12} md={12} lg={6}>

            <TextInput source="accept" label="Accept Condition Text" fullWidth />
          </Grid>

          <Grid item sm={12} md={12} lg={6}>

            <TextInput source="description1" label="Description1" fullWidth />

          </Grid>
          <Grid item sm={12} md={12} lg={6}>

            <TextInput source="description2" label="Description2" fullWidth />
          </Grid>


          <Grid item sm={12} md={4} lg={4}>

            <TextInput source="field1" label="field1" fullWidth />
          </Grid>

          <Grid item sm={12} md={4} lg={4}>

            <TextInput source="field2" label="field2" fullWidth />
          </Grid>
          <Grid item sm={12} md={4} lg={4}>

            <TextInput source="field3" label="field3" fullWidth />
          </Grid>
          <Grid item sm={12} md={4} lg={4}>

            <TextInput source="field4" label="field4" fullWidth />
          </Grid>

          <Grid item sm={12} md={4} lg={4}>

            <TextInput source="field5" label="field5" fullWidth />
          </Grid>




        </SanitizedGrid>
      </SimpleForm>
    </Edit>
  );
};

export default MarketResearchCustomizationEdit;
